import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
export const useTourSearchWrapper = () => {
  const $ = _c(19);
  const router = useRouter();
  const [isSearchPanelOpen, setIsSearchPanelOpen] = useState(false);
  let t0;
  if ($[0] !== router) {
    t0 = (key_0, value) => {
      const {
        pathname,
        query
      } = router;
      const newQuery = {
        ...query,
        [key_0]: value
      };
      router.replace({
        pathname,
        query: newQuery
      }, undefined, {
        shallow: true
      });
    };
    $[0] = router;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const addItemToQueryString = t0;
  let t1;
  if ($[2] !== router) {
    t1 = key_1 => {
      const {
        pathname: pathname_0,
        query: query_0
      } = router;
      const newQuery_0 = {
        ...query_0
      };
      delete newQuery_0[key_1];
      router.replace({
        pathname: pathname_0,
        query: newQuery_0
      }, undefined, {
        shallow: true
      });
    };
    $[2] = router;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const removeItemFromQueryString = t1;
  let t2;
  if ($[4] !== router.query.OPEN_SEARCH) {
    t2 = () => {
      const q = router.query.OPEN_SEARCH;
      if (q) {
        setIsSearchPanelOpen(true);
      } else {
        setIsSearchPanelOpen(false);
      }
    };
    $[4] = router.query.OPEN_SEARCH;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== router.query) {
    t3 = [router.query];
    $[6] = router.query;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[8] !== isSearchPanelOpen) {
    t4 = () => {
      if (isSearchPanelOpen) {
        document.body.classList.add("prevent-scroll");
        return _temp;
      }
    };
    t5 = [isSearchPanelOpen];
    $[8] = isSearchPanelOpen;
    $[9] = t4;
    $[10] = t5;
  } else {
    t4 = $[9];
    t5 = $[10];
  }
  useEffect(t4, t5);
  let t6;
  if ($[11] !== removeItemFromQueryString) {
    t6 = () => {
      removeItemFromQueryString("OPEN_SEARCH");
    };
    $[11] = removeItemFromQueryString;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const handleClose = t6;
  let t7;
  if ($[13] !== addItemToQueryString) {
    t7 = () => {
      addItemToQueryString("OPEN_SEARCH", "true");
    };
    $[13] = addItemToQueryString;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const handleOpen = t7;
  let t8;
  if ($[15] !== handleClose || $[16] !== handleOpen || $[17] !== isSearchPanelOpen) {
    t8 = {
      isSearchPanelOpen,
      handleClose,
      handleOpen
    };
    $[15] = handleClose;
    $[16] = handleOpen;
    $[17] = isSearchPanelOpen;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
};
function _temp() {
  return document.body.classList.remove("prevent-scroll");
}